import { connect } from "react-redux";
import { browserHistory } from "react-router";
import appPath from "utils/appPath";
import { getAbbaConfig } from "ducks/abba";
import userActions from "ducks/user";
import loginActions from "ducks/loginRegister";
import forgotPasswordActions from "ducks/forgotPassword";
import { setThinking, doneThinking } from "ducks/thinking";
import { SCREENS, FLOWS, SOCIAL_MEDIA } from "common/constants/Constants";

export function createMapStateToProps() {
    return (state) => {
        const {
            abba,
            config: {
                bloombergSiteUrl
            },
            loginRegister: {
                password,
                confirmationPassword,
                errors
            },
            thinking
        } = state;

        return {
            abba,
            bloombergSiteUrl,
            thinking,
            password,
            confirmationPassword,
            errors
        };
    };
}

export function mapDispatchToProps(dispatch, ownProps) {
    return {
        init() {
            const flow = window.location.pathname === appPath.withoutQuery(SCREENS.RESET_PASSWORD)
                ? FLOWS.RESET_PASSWORD
                : FLOWS.REGISTER;

            dispatch(loginActions.setFlow(flow));
            dispatch(loginActions.setEmail(ownProps.location.query.email));
        },

        onPasswordChange(newPassword) {
            return dispatch(loginActions.passwordChange(newPassword));
        },

        onConfirmationPasswordChange(confirmationPassword) {
            return dispatch(loginActions.confirmationPasswordChange(confirmationPassword));
        },

        fetchAbba() {
            return dispatch(getAbbaConfig());
        },

        onPasswordSubmit(newPassword) {
            const isNewUser = window.location.pathname !== appPath(SCREENS.RESET_PASSWORD);
            const { location } = ownProps;
            const {
                email,
                validationKey
            } = location.query;

            return dispatch(userActions.resetPasswordAndRedirect(isNewUser, email, validationKey, newPassword, location));
        },

        resendConfirmationEmail(email) {
            dispatch(setThinking());

            return dispatch(forgotPasswordActions.forgotPassword(email))
                .then(() => {
                    browserHistory.push(appPath.withIframePrefix(SCREENS.EMAIL_RESENT));
                })
                .then(() => dispatch(doneThinking()))
                .catch(() => dispatch(doneThinking()));
        },

        socialLogin(socialSite) {
            dispatch(doneThinking());

            return dispatch(loginActions.socialLogin(socialSite))
                .then(() => redirectIfTerminalUser(socialSite))
                .then(() => dispatch(userActions.startFetchingUser()))
                .then((user) => dispatch(loginActions.redirectAfterSignIn(user)))
                .then(() => dispatch(doneThinking()))
                .catch((error) => {
                    dispatch(doneThinking());

                    if (error.status === 401) {
                        browserHistory.push(appPath(SCREENS.REGISTER));
                    }
                });
        }
    };
}

function redirectIfTerminalUser(socialSite) {
    if (socialSite === SOCIAL_MEDIA.TERMINAL) {
        browserHistory.push(appPath(SCREENS.ACCOUNT));

        return Promise.reject();
    }

    return Promise.resolve();
}

function createSetPasswordContainer(component) {
    return connect(
        createMapStateToProps(),
        mapDispatchToProps
    )(component);
}

export default createSetPasswordContainer;
